import { takeLatest, call, put, select } from 'redux-saga/effects';
import {
    getAuditLogsSuccess, getAuditLogsFailure,
    exportAuditLogsSuccess, exportAuditLogsFailure,
} from './slice';
import requestHandler from '../../../utils/requestHandler';
import { logoutRequest } from '../auth/authSlice';

function* getRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { page = 1, limit = 25, eventType, resourceType, userId, dateFrom, dateTo, patientId } = action.payload || {};

        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/audit-logs?page=${page}&limit=${limit}`;
        if (eventType) url += `&eventType=${eventType}`;
        if (resourceType) url += `&resourceType=${resourceType}`;
        if (userId) url += `&userId=${userId}`;
        if (dateFrom) url += `&dateFrom=${dateFrom}`;
        if (dateTo) url += `&dateTo=${dateTo}`;
        if (patientId) url += `&patientId=${patientId}`;

        const requestDetail = {
            method: "GET",
            headers: { "Authorization": authToken, "Content-Type": "application/json", "X-Current-Branch": currentBranch.id }
        };
        const response = yield call(requestHandler, url, requestDetail);
        yield put(getAuditLogsSuccess(response));
    } catch (error) {
        yield put(getAuditLogsFailure(error?.response?.message || error));
    }
}

function* exportRequest(action) {
    try {
        let authToken = localStorage.getItem("item");
        if (!authToken) { yield put(logoutRequest()); return; }
        const currentBranch = yield select(state => state.branch.currentBranch);
        const { eventType, resourceType, userId, dateFrom, dateTo, patientId } = action.payload || {};

        const params = [];
        if (eventType) params.push(`eventType=${eventType}`);
        if (resourceType) params.push(`resourceType=${resourceType}`);
        if (userId) params.push(`userId=${userId}`);
        if (dateFrom) params.push(`dateFrom=${dateFrom}`);
        if (dateTo) params.push(`dateTo=${dateTo}`);
        if (patientId) params.push(`patientId=${patientId}`);
        let url = `${process.env.REACT_APP_SERVER_API}api/laboratory/audit-logs/export${params.length ? '?' + params.join('&') : ''}`;

        // For CSV download, we'll use fetch directly
        const response = yield call(fetch, url, {
            headers: { "Authorization": authToken, "X-Current-Branch": currentBranch.id }
        });
        const blob = yield call([response, 'blob']);
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = `audit-logs-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(downloadUrl);
        yield put(exportAuditLogsSuccess({ success: true }));
    } catch (error) {
        yield put(exportAuditLogsFailure(error?.response?.message || error));
    }
}

function* saga() {
    yield takeLatest('auditLog/getAuditLogsRequest', getRequest);
    yield takeLatest('auditLog/exportAuditLogsRequest', exportRequest);
}

export default saga;
